import { API_KEY_STATUS_TYPE } from '@/const/shared';
import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';

export const API_KEY_STATUS_TEXT_DB = {
  [API_KEY_STATUS_TYPE.ACTIVE]: 'Active',
  [API_KEY_STATUS_TYPE.EXPIRED]: 'Expired',
};

export const STATUS_API_KEY_MAP: StatusType = {
  [API_KEY_STATUS_TYPE.ACTIVE]: { variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [API_KEY_STATUS_TYPE.EXPIRED]: { variant: STATUS_VARIANT_HIGHLIGHT.RED },
};
